var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Row, Col } from "react-bootstrap";
import React, { Component, Fragment } from "react";
import linkedCardService from "@irati/perksgo/services/linkedcards";
import authentication from "@irati/auth";
import Hr from "@irati/ui/src/Layout/Hr";
import { H1, Body } from "@irati/ui/src/Typography";
import Flex from "@irati/ui/src/Flex";
import { SmallCaption, Strong } from "@irati/ui/src/Labels";
import Loading from "@irati/ui/src/Loading";
import Card from "@irati/ui/src/Layout/Card";
import FindOutMorePopup from "@irati-web/perksgo/src/components/Popup/FindOutMore";
import History from "@irati/utils/history";
import { FormattedMessage, getResolvedMessage, injectIntl } from "@irati/utils/lang";
import { hangPromise } from "@irati/utils/promise";
import notify from "@irati/utils/notify";
import CancellationPopup from "@irati/ui/src/CancellationPopup";
import perksGOTracking from "@irati-tracking/perksgo/perksGO";
import ModalLocation from "@irati-tracking/perksgo/enums/ModalLocation";
import Button from "@irati/ui/src/Button";
import EmptyState from "../../components/EmptyState/EmptyState";
import UserLinkedCard from "../../components/UserLinkedCard";
import noCardsLogo from "../../images/no-linked-cards.png";
import { PerksGOIcon, RightCol } from "./styled";
var PerksGOLinkedCards = /** @class */ (function (_super) {
    __extends(PerksGOLinkedCards, _super);
    function PerksGOLinkedCards(props) {
        var _this = _super.call(this, props) || this;
        _this.findOutMorePopup = React.createRef();
        _this.cancellation = React.createRef();
        _this.listCards = function () {
            var userId = authentication.user().uuid;
            return linkedCardService.getPerksGOCards({ userId: userId }).then(function (linkedCards) {
                _this.setState({ linkedCards: linkedCards });
            });
        };
        _this.shouldShowModal = function () {
            if (_this.props.match.params.action === "add") {
                _this.showModal();
            }
        };
        _this.showModal = function () {
            perksGOTracking.showFindOutMoreModal(ModalLocation.MyLinkedCards);
            _this.findOutMorePopup.current.show();
        };
        _this.hideModal = function () {
            History.push("account/settings/linkedcards");
            _this.listCards();
        };
        _this.onLinkCardButtonClick = function () {
            perksGOTracking.clickLinkNewCard();
            if (_this.props.match.params.action !== "add") {
                History.push("account/settings/linkedcards/add");
            }
            else {
                _this.showModal();
            }
        };
        _this.handleShowUnlinkCardPopup = function (card) {
            perksGOTracking.clickDeleteLinkedCard();
            _this.cancellation.current.popup.open();
            _this.setState({ selectedCard: card });
        };
        _this.handleCloseUnlinkCardPopup = function () {
            perksGOTracking.cancelDeleteLinkedCard();
            _this.cancellation.current.popup.close();
            _this.setState({ selectedCard: undefined });
        };
        _this.handleUnlinkCard = function () {
            var selectedCard = _this.state.selectedCard;
            if (selectedCard) {
                var cardUuid = selectedCard.uuid;
                linkedCardService
                    .unlinkCard({ cardUuid: cardUuid })
                    .then(function () { return _this.handleUnlinkSuccess(selectedCard); })
                    .catch(function (err) {
                    notify.error({
                        message: getResolvedMessage(_this, "message", err),
                        position: "top-right"
                    });
                    _this.handleCloseUnlinkCardPopup();
                });
            }
        };
        _this.handleUnlinkSuccess = function (card) {
            if (!card)
                return;
            var formatMessage = _this.props.formatMessage;
            var linkedCards = _this.state.linkedCards;
            var lastFour = card.lastFour;
            perksGOTracking.confirmDeleteLinkedCard(linkedCards.length - 1);
            notify.success({
                message: formatMessage({ id: "account.linked.unlinkCard.success.message" }, { lastFour: lastFour }),
                position: "top-right"
            });
            _this.listCards();
            _this.handleCloseUnlinkCardPopup();
        };
        _this.state = {
            load: hangPromise()
        };
        return _this;
    }
    PerksGOLinkedCards.prototype.componentDidMount = function () {
        this.setState({ load: this.listCards() });
        this.shouldShowModal();
    };
    PerksGOLinkedCards.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            this.shouldShowModal();
        }
    };
    PerksGOLinkedCards.prototype.render = function () {
        var _this = this;
        var formatMessage = this.props.formatMessage;
        var _a = this.state, load = _a.load, linkedCards = _a.linkedCards;
        var hasLinkedCards = linkedCards && linkedCards.length > 0;
        var addCardButtonText = hasLinkedCards ? "account.linked.addButton" : "account.linked.empty.addButton";
        return (React.createElement(React.Fragment, null,
            React.createElement(Card, { tiny: true, noBorder: true },
                React.createElement(Flex, { justifyContent: "space-between", alignItems: "center" },
                    React.createElement(H1, { marginBottom: 4 },
                        React.createElement(FormattedMessage, { id: "account.linked.header" })),
                    hasLinkedCards && React.createElement(PerksGOIcon, { icon: "perksGO", size: 40 })),
                React.createElement(Loading, { load: load },
                    hasLinkedCards && (React.createElement(React.Fragment, null,
                        React.createElement(Body, { marginBottom: 4 },
                            React.createElement(FormattedMessage, { id: "account.linked.perksGOIntro" })),
                        React.createElement(Body, { marginBottom: 3 },
                            React.createElement(FormattedMessage, { id: "account.linked.perksGONote", values: {
                                    strong: (React.createElement("strong", null,
                                        React.createElement(FormattedMessage, { id: "account.linked.perksGONoteStrong" })))
                                } })),
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 6 },
                                React.createElement(SmallCaption, { uppercase: true },
                                    React.createElement(FormattedMessage, { id: "account.linked.card.cardNumber" }))),
                            React.createElement(RightCol, { xs: 3 },
                                React.createElement(SmallCaption, { uppercase: true },
                                    React.createElement(FormattedMessage, { id: "account.linked.card.expDate" })))),
                        React.createElement(Hr, { marginTop: 1 }),
                        linkedCards.map(function (card) { return (React.createElement(Fragment, { key: card.uuid },
                            React.createElement(UserLinkedCard, __assign({ card: card, onClick: _this.handleShowUnlinkCardPopup }, card)),
                            React.createElement(Hr, null))); }))),
                    Array.isArray(linkedCards) && !hasLinkedCards && (React.createElement(EmptyState, { renderDescription: function () { return (React.createElement(FormattedMessage, { id: "account.linked.empty.perksGo.text", values: {
                                boldText: (React.createElement(Strong, null,
                                    React.createElement(FormattedMessage, { id: "account.linked.empty.perksGo.bold" })))
                            } })); }, src: noCardsLogo, alt: formatMessage({ id: "account.linked.empty.alt" }) })),
                    React.createElement(Button, { primary: true, large: true, onClick: this.onLinkCardButtonClick, marginTop: 4 },
                        React.createElement(FormattedMessage, { id: addCardButtonText })))),
            React.createElement(FindOutMorePopup, { ref: this.findOutMorePopup, modalLocation: ModalLocation.MyLinkedCards, onHide: this.hideModal, linkedCards: linkedCards }),
            React.createElement(CancellationPopup, { ref: this.cancellation, onConfirm: this.handleUnlinkCard, onCancel: this.handleCloseUnlinkCardPopup, headerText: formatMessage({ id: "account.linked.unlinkCardPopup.header" }), headerBody: formatMessage({ id: "account.linked.unlinkCardPopup.subHeader" }), cancelButtonText: formatMessage({ id: "account.linked.unlinkCardPopup.button.no" }), confirmButtonText: formatMessage({ id: "account.linked.unlinkCardPopup.button.yes" }), cancelImage: formatMessage({ id: "account.linked.cancellationPopUp.image" }) })));
    };
    return PerksGOLinkedCards;
}(Component));
export default injectIntl(PerksGOLinkedCards);
